import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, vModelSelect as _vModelSelect, normalizeClass as _normalizeClass, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "hero" }
const _hoisted_2 = { class: "hero-body" }
const _hoisted_3 = { class: "container" }
const _hoisted_4 = { class: "content" }
const _hoisted_5 = { class: "content-body" }
const _hoisted_6 = { class: "header" }
const _hoisted_7 = { class: "title is-5" }
const _hoisted_8 = { class: "columns" }
const _hoisted_9 = { class: "column" }
const _hoisted_10 = { class: "field" }
const _hoisted_11 = { class: "label" }
const _hoisted_12 = { class: "control" }
const _hoisted_13 = ["placeholder"]
const _hoisted_14 = { class: "column" }
const _hoisted_15 = { class: "field" }
const _hoisted_16 = { class: "label" }
const _hoisted_17 = { class: "control" }
const _hoisted_18 = ["placeholder"]
const _hoisted_19 = { class: "column" }
const _hoisted_20 = { class: "field" }
const _hoisted_21 = { class: "label" }
const _hoisted_22 = { class: "control" }
const _hoisted_23 = ["placeholder"]
const _hoisted_24 = { class: "columns" }
const _hoisted_25 = { class: "column" }
const _hoisted_26 = { class: "field" }
const _hoisted_27 = { class: "label" }
const _hoisted_28 = { class: "control" }
const _hoisted_29 = ["placeholder"]
const _hoisted_30 = { class: "column" }
const _hoisted_31 = { class: "field" }
const _hoisted_32 = { class: "label" }
const _hoisted_33 = { class: "control" }
const _hoisted_34 = ["placeholder"]
const _hoisted_35 = { class: "column" }
const _hoisted_36 = { class: "field" }
const _hoisted_37 = { class: "label" }
const _hoisted_38 = { class: "control" }
const _hoisted_39 = ["placeholder"]
const _hoisted_40 = { class: "column" }
const _hoisted_41 = { class: "field" }
const _hoisted_42 = { class: "label" }
const _hoisted_43 = { class: "control" }
const _hoisted_44 = ["placeholder"]
const _hoisted_45 = { class: "column" }
const _hoisted_46 = { class: "field" }
const _hoisted_47 = { class: "label" }
const _hoisted_48 = { class: "control" }
const _hoisted_49 = { class: "select is-fullwidth" }
const _hoisted_50 = ["placeholder"]
const _hoisted_51 = { value: "" }
const _hoisted_52 = { class: "columns" }
const _hoisted_53 = { class: "column is-6" }
const _hoisted_54 = ["innerHTML"]
const _hoisted_55 = { class: "column is-2" }
const _hoisted_56 = { class: "field" }
const _hoisted_57 = { class: "label" }
const _hoisted_58 = { class: "control" }
const _hoisted_59 = ["placeholder"]
const _hoisted_60 = { class: "column is-4" }
const _hoisted_61 = { class: "field" }
const _hoisted_62 = { class: "label" }
const _hoisted_63 = ["placeholder"]
const _hoisted_64 = { class: "columns" }
const _hoisted_65 = { class: "column is-half" }
const _hoisted_66 = { class: "field" }
const _hoisted_67 = { class: "label" }
const _hoisted_68 = { class: "control" }
const _hoisted_69 = ["placeholder"]
const _hoisted_70 = { class: "column is-one-quarter" }
const _hoisted_71 = { class: "field" }
const _hoisted_72 = { class: "label" }
const _hoisted_73 = { class: "control" }
const _hoisted_74 = ["placeholder"]
const _hoisted_75 = { class: "column is-one-quarter" }
const _hoisted_76 = { class: "field" }
const _hoisted_77 = { class: "label" }
const _hoisted_78 = { class: "control" }
const _hoisted_79 = ["placeholder"]
const _hoisted_80 = { class: "content-body" }
const _hoisted_81 = { class: "field is-grouped is-grouped-right" }
const _hoisted_82 = {
  key: 0,
  class: "control"
}
const _hoisted_83 = {
  type: "submit",
  class: "button is-primary"
}
const _hoisted_84 = {
  key: 1,
  class: "control"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Navbar = _resolveComponent("Navbar")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_Navbar),
    _createElementVNode("section", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("form", {
              onSubmit: _cache[15] || (_cache[15] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.createCustomerMeth && _ctx.createCustomerMeth(...args)), ["prevent"]))
            }, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("form", {
                  onSubmit: _cache[13] || (_cache[13] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.createCustomerMeth && _ctx.createCustomerMeth(...args)), ["prevent"]))
                }, [
                  _createElementVNode("div", _hoisted_6, [
                    _createElementVNode("h5", _hoisted_7, _toDisplayString(_ctx.$t('CustomerData.PleaseEnterYourCustomerData')), 1)
                  ]),
                  _createElementVNode("div", _hoisted_8, [
                    _createElementVNode("div", _hoisted_9, [
                      _createElementVNode("div", _hoisted_10, [
                        _createElementVNode("label", _hoisted_11, _toDisplayString(_ctx.$t('CustomerData.Name')), 1),
                        _createElementVNode("div", _hoisted_12, [
                          _withDirectives(_createElementVNode("input", {
                            minlength: 2,
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.getNewCustomerData.name) = $event)),
                            class: "input",
                            type: "text",
                            placeholder: _ctx.$t('CustomerData.NamePlaceholder'),
                            required: ""
                          }, null, 8, _hoisted_13), [
                            [_vModelText, _ctx.getNewCustomerData.name]
                          ])
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_14, [
                      _createElementVNode("div", _hoisted_15, [
                        _createElementVNode("label", _hoisted_16, _toDisplayString(_ctx.$t('CustomerData.Email')), 1),
                        _createElementVNode("div", _hoisted_17, [
                          _withDirectives(_createElementVNode("input", {
                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.getNewCustomerData.email) = $event)),
                            class: "input",
                            type: "email",
                            placeholder: _ctx.replaceSpecialCharacters(_ctx.$t('CustomerData.EmailPlaceholder')),
                            required: ""
                          }, null, 8, _hoisted_18), [
                            [_vModelText, _ctx.getNewCustomerData.email]
                          ])
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_19, [
                      _createElementVNode("div", _hoisted_20, [
                        _createElementVNode("label", _hoisted_21, _toDisplayString(_ctx.$t('UserData.PhoneNumber')), 1),
                        _createElementVNode("div", _hoisted_22, [
                          _withDirectives(_createElementVNode("input", {
                            minlength: 6,
                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.getNewCustomerData.phone) = $event)),
                            class: "input",
                            type: "tel",
                            placeholder: _ctx.$t('UserData.PhoneNumberPlaceholder'),
                            required: ""
                          }, null, 8, _hoisted_23), [
                            [_vModelText, _ctx.getNewCustomerData.phone]
                          ])
                        ])
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_24, [
                    _createElementVNode("div", _hoisted_25, [
                      _createElementVNode("div", _hoisted_26, [
                        _createElementVNode("label", _hoisted_27, _toDisplayString(_ctx.$t('CustomerData.VATNumber')), 1),
                        _createElementVNode("div", _hoisted_28, [
                          _withDirectives(_createElementVNode("input", {
                            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.getNewCustomerData.tax_id) = $event)),
                            class: "input",
                            type: "text",
                            placeholder: _ctx.$t('CustomerData.VATNumberPlaceholder'),
                            required: ""
                          }, null, 8, _hoisted_29), [
                            [_vModelText, _ctx.getNewCustomerData.tax_id]
                          ])
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_30, [
                      _createElementVNode("div", _hoisted_31, [
                        _createElementVNode("label", _hoisted_32, _toDisplayString(_ctx.$t('CustomerData.Password')), 1),
                        _createElementVNode("div", _hoisted_33, [
                          _withDirectives(_createElementVNode("input", {
                            minlength: 6,
                            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.getNewCustomerData.password) = $event)),
                            class: "input",
                            type: "password",
                            placeholder: _ctx.$t('CustomerData.PasswordPlaceholder'),
                            required: ""
                          }, null, 8, _hoisted_34), [
                            [_vModelText, _ctx.getNewCustomerData.password]
                          ])
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_35, [
                      _createElementVNode("div", _hoisted_36, [
                        _createElementVNode("label", _hoisted_37, _toDisplayString(_ctx.$t('CustomerData.PassConfirmation')), 1),
                        _createElementVNode("div", _hoisted_38, [
                          _withDirectives(_createElementVNode("input", {
                            minlength: 6,
                            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.getNewCustomerData.confirmation) = $event)),
                            class: "input",
                            type: "password",
                            placeholder: _ctx.$t('CustomerData.PassConfirmationPlaceholder'),
                            required: ""
                          }, null, 8, _hoisted_39), [
                            [_vModelText, _ctx.getNewCustomerData.confirmation]
                          ])
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_40, [
                      _createElementVNode("div", _hoisted_41, [
                        _createElementVNode("label", _hoisted_42, _toDisplayString(_ctx.$t('CustomerData.CRMVNumber')), 1),
                        _createElementVNode("div", _hoisted_43, [
                          _withDirectives(_createElementVNode("input", {
                            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.getNewCustomerData.crmv) = $event)),
                            class: "input",
                            type: "number",
                            placeholder: _ctx.$t('CustomerData.CRMVPlaceholder')
                          }, null, 8, _hoisted_44), [
                            [_vModelText, _ctx.getNewCustomerData.crmv]
                          ])
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_45, [
                      _createElementVNode("div", _hoisted_46, [
                        _createElementVNode("label", _hoisted_47, _toDisplayString(_ctx.$t('CustomerData.CRMVState')), 1),
                        _createElementVNode("div", _hoisted_48, [
                          _createElementVNode("div", _hoisted_49, [
                            _withDirectives(_createElementVNode("select", {
                              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.getNewCustomerData.crmv_state) = $event)),
                              placeholder: _ctx.$t('CustomerData.SelectState')
                            }, [
                              _createElementVNode("option", _hoisted_51, "-- " + _toDisplayString(_ctx.$t('CustomerData.SelectState')) + " --", 1),
                              _cache[16] || (_cache[16] = _createStaticVNode("<option value=\"AC\" data-v-58d35f7d>Acre</option><option value=\"AL\" data-v-58d35f7d>Alagoas</option><option value=\"AP\" data-v-58d35f7d>Amapá</option><option value=\"AM\" data-v-58d35f7d>Amazonas</option><option value=\"BA\" data-v-58d35f7d>Bahia</option><option value=\"CE\" data-v-58d35f7d>Ceará</option><option value=\"DF\" data-v-58d35f7d>Distrito Federal</option><option value=\"ES\" data-v-58d35f7d>Espírito Santo</option><option value=\"GO\" data-v-58d35f7d>Goiás</option><option value=\"MA\" data-v-58d35f7d>Maranhão</option><option value=\"MT\" data-v-58d35f7d>Mato Grosso</option><option value=\"MS\" data-v-58d35f7d>Mato Grosso do Sul</option><option value=\"MG\" data-v-58d35f7d>Minas Gerais</option><option value=\"PA\" data-v-58d35f7d>Pará</option><option value=\"PB\" data-v-58d35f7d>Paraíba</option><option value=\"PR\" data-v-58d35f7d>Paraná</option><option value=\"PE\" data-v-58d35f7d>Pernambuco</option><option value=\"PI\" data-v-58d35f7d>Piauí</option><option value=\"RJ\" data-v-58d35f7d>Rio de Janeiro</option><option value=\"RN\" data-v-58d35f7d>Rio Grande do Norte</option><option value=\"RS\" data-v-58d35f7d>Rio Grande do Sul</option><option value=\"RO\" data-v-58d35f7d>Rondônia</option><option value=\"RR\" data-v-58d35f7d>Roraima</option><option value=\"SC\" data-v-58d35f7d>Santa Catarina</option><option value=\"SP\" data-v-58d35f7d>São Paulo</option><option value=\"SE\" data-v-58d35f7d>Sergipe</option><option value=\"TO\" data-v-58d35f7d>Tocantins</option>", 27))
                            ], 8, _hoisted_50), [
                              [_vModelSelect, _ctx.getNewCustomerData.crmv_state]
                            ])
                          ])
                        ])
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_52, [
                    _createElementVNode("div", _hoisted_53, [
                      _createElementVNode("div", {
                        class: "notification is-light is-small",
                        innerHTML: _ctx.$t('CustomerData.PostalCodeSearchNote')
                      }, null, 8, _hoisted_54)
                    ]),
                    _createElementVNode("div", _hoisted_55, [
                      _createElementVNode("div", _hoisted_56, [
                        _createElementVNode("label", _hoisted_57, _toDisplayString(_ctx.$t('CustomerData.PostalCode')), 1),
                        _createElementVNode("div", _hoisted_58, [
                          _withDirectives(_createElementVNode("input", {
                            "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.getNewCustomerData.postal_code) = $event)),
                            class: "input",
                            type: "text",
                            placeholder: _ctx.$t('CustomerData.PostalCodePlaceholder'),
                            required: ""
                          }, null, 8, _hoisted_59), [
                            [_vModelText, _ctx.getNewCustomerData.postal_code]
                          ])
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_60, [
                      _createElementVNode("div", _hoisted_61, [
                        _createElementVNode("label", _hoisted_62, _toDisplayString(_ctx.$t('CustomerData.City')), 1),
                        _createElementVNode("div", {
                          class: _normalizeClass(["control", { 'is-loading': _ctx.postalCodeIsLoading }])
                        }, [
                          _withDirectives(_createElementVNode("input", {
                            "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.getNewCustomerData.city) = $event)),
                            class: "input",
                            type: "text",
                            placeholder: _ctx.$t('CustomerData.CityPlaceholder'),
                            required: ""
                          }, null, 8, _hoisted_63), [
                            [_vModelText, _ctx.getNewCustomerData.city]
                          ])
                        ], 2)
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_64, [
                    _createElementVNode("div", _hoisted_65, [
                      _createElementVNode("div", _hoisted_66, [
                        _createElementVNode("label", _hoisted_67, _toDisplayString(_ctx.$t('CustomerData.Address')), 1),
                        _createElementVNode("div", _hoisted_68, [
                          _withDirectives(_createElementVNode("input", {
                            "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.getNewCustomerData.address) = $event)),
                            class: "input",
                            type: "text",
                            placeholder: _ctx.$t('CustomerData.AddressPlaceholder'),
                            required: ""
                          }, null, 8, _hoisted_69), [
                            [_vModelText, _ctx.getNewCustomerData.address]
                          ])
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_70, [
                      _createElementVNode("div", _hoisted_71, [
                        _createElementVNode("label", _hoisted_72, _toDisplayString(_ctx.$t('CustomerData.State')), 1),
                        _createElementVNode("div", _hoisted_73, [
                          _withDirectives(_createElementVNode("input", {
                            "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.getNewCustomerData.state) = $event)),
                            class: "input",
                            type: "text",
                            placeholder: _ctx.$t('CustomerData.StatePlaceholder'),
                            required: ""
                          }, null, 8, _hoisted_74), [
                            [_vModelText, _ctx.getNewCustomerData.state]
                          ])
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_75, [
                      _createElementVNode("div", _hoisted_76, [
                        _createElementVNode("label", _hoisted_77, _toDisplayString(_ctx.$t('CustomerData.Country')), 1),
                        _createElementVNode("div", _hoisted_78, [
                          _withDirectives(_createElementVNode("input", {
                            "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.getNewCustomerData.country) = $event)),
                            class: "input",
                            type: "text",
                            placeholder: _ctx.$t('CustomerData.CountryPlaceholder'),
                            required: ""
                          }, null, 8, _hoisted_79), [
                            [_vModelText, _ctx.getNewCustomerData.country]
                          ])
                        ])
                      ])
                    ])
                  ])
                ], 32)
              ]),
              _createElementVNode("div", _hoisted_80, [
                _createElementVNode("div", _hoisted_81, [
                  (!_ctx.addingPet && !_ctx.getEditingPet)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_82, [
                        _createElementVNode("button", _hoisted_83, _toDisplayString(_ctx.$t('General.Save')), 1)
                      ]))
                    : _createCommentVNode("", true),
                  (!_ctx.addingPet && !_ctx.getEditingPet)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_84, [
                        _createElementVNode("a", {
                          onClick: _cache[14] || (_cache[14] = 
//@ts-ignore
(...args) => (_ctx.cancelRegistration && _ctx.cancelRegistration(...args))),
                          class: "button is-light"
                        }, _toDisplayString(_ctx.$t('General.Cancel')), 1)
                      ]))
                    : _createCommentVNode("", true)
                ])
              ])
            ], 32)
          ])
        ])
      ])
    ])
  ]))
}